var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _ellipse, _ellipse2, _path2, _path3, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _ellipse3, _ellipse4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoDeadlines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 112,
    viewBox: "0 0 118 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8888 90.6544C13.2376 88.0634 15.0649 81.7485 19.5836 77.2173C25.2321 71.5533 33.9837 59.6224 34.4659 58.2307C34.9481 56.8391 35.3181 47.5565 36.6034 45.2049C37.8887 42.8534 41.3695 37.3342 41.658 36.2221C41.9464 35.11 47.9559 27.8315 48.5733 26.7418C49.1908 25.6521 53.6986 18.1541 55.9285 15.6328C58.1583 13.1115 61.2403 13.5363 64.542 11.5564C66.005 9.74384 69.0804 6.49966 69.7464 6.13529C70.0989 5.94247 70.8995 5.966 71.5442 6.1936C72.0469 5.9761 73.2845 6.02134 74.2132 7.94235C75.1043 9.78552 75.1345 12.1678 74.8631 13.6978C74.9195 13.4118 75.869 13.1092 76.3332 13.4336C76.7046 13.6931 76.9865 14.351 77.081 14.6475C78.4307 14.3239 79.9645 13.9471 81.2398 13.612C84.1884 12.8374 84.9897 12.775 85.4254 12.8598C85.861 12.9446 86.3565 15.8732 86.4414 16.3473C87.2226 15.9623 89.3598 16.3122 91.691 16.6272C94.0222 16.9423 99.4741 19.7142 100.61 20.1624C101.747 20.6107 102.048 20.4751 103.638 22.5544C105.229 24.6337 105.477 25.5678 105.609 27.6647C105.74 29.7616 104.277 31.5742 103.797 32.0683C103.413 32.4636 102.452 33.4791 102.019 33.9374C101.582 35.1252 100.774 36.3633 100.425 36.8338C100.797 37.0933 101.685 39.7882 102.698 40.911C103.712 42.0338 104.852 43.8678 106.257 45.8174C107.662 47.767 107.576 51.3711 107.193 53.3158C106.81 55.2605 103.853 56.4444 102.543 56.8429C102.749 57.5399 103.102 59.2382 102.865 60.4553C102.655 61.531 102.604 63.0675 101.777 64.3678C102.633 64.6063 104.39 65.7109 104.579 68.2215C104.816 71.3598 104.092 72.9581 102.951 73.6523C101.811 74.3466 98.1967 76.1381 95.9503 76.2971L98.5803 90.9944L99.3014 95.0244C94.5149 96.7274 84.5236 99.703 82.8506 97.981C82.0282 94.4749 79.9377 85.1832 78.9952 80.9755C77.6626 82.0034 74.8625 84.214 74.3233 84.8329C73.6493 85.6065 72.8764 85.827 72.0652 87.1961C71.254 88.5653 67.7874 94.1634 63.5756 96.9594C60.2061 99.1961 54.3064 103.274 51.7777 105.034C25.9136 111.493 15.0751 98.1388 12.8888 90.6544Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 0.802731,
    height: 1.75941,
    rx: 0.401365,
    transform: "matrix(0.176145 0.984364 -0.984231 0.17689 84.114 41.4778)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.802731,
    height: 1.75941,
    rx: 0.401365,
    transform: "matrix(0.176145 0.984364 -0.984231 0.17689 83.0959 35.7886)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 0.799732,
    height: 1.76601,
    rx: 0.399866,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 70.9182 42.2185)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 0.802731,
    height: 1.75941,
    rx: 0.401365,
    transform: "matrix(0.176145 0.984364 -0.984231 0.17689 73.7764 43.6619)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 0.802731,
    height: 1.75941,
    rx: 0.401365,
    transform: "matrix(0.176145 0.984364 -0.984231 0.17689 73.2673 40.8171)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 0.802731,
    height: 1.75941,
    rx: 0.401365,
    transform: "matrix(0.176145 0.984364 -0.984231 0.17689 72.7583 37.9727)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 0.799732,
    height: 1.76601,
    rx: 0.399866,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 70.4087 39.3735)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 0.799732,
    height: 1.76601,
    rx: 0.399866,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 73.4373 41.7654)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 0.799732,
    height: 1.76601,
    rx: 0.399866,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 81.2559 40.0344)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 0.799732,
    height: 1.76601,
    rx: 0.399866,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 80.7468 37.1897)",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 0.799732,
    height: 1.76601,
    rx: 0.399866,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 83.2654 36.7371)",
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 0.799732,
    height: 1.76601,
    rx: 0.399866,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 83.7744 39.5815)",
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 0.802731,
    height: 1.75941,
    rx: 0.401365,
    transform: "matrix(0.176145 0.984364 -0.984231 0.17689 88.7302 40.5393)",
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 0.802731,
    height: 1.75941,
    rx: 0.401365,
    transform: "matrix(0.176145 0.984364 -0.984231 0.17689 87.7119 34.8501)",
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 0.799732,
    height: 1.76601,
    rx: 0.399866,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 85.8718 39.0957)",
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 0.799732,
    height: 1.76601,
    rx: 0.399866,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 85.3628 36.2512)",
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 0.799732,
    height: 1.76601,
    rx: 0.399866,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 87.8813 35.7986)",
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 0.799732,
    height: 1.76601,
    rx: 0.399866,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 88.3904 38.6431)",
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 0.802731,
    height: 1.75941,
    rx: 0.401365,
    transform: "matrix(0.176145 0.984364 -0.984231 0.17689 78.1377 42.7251)",
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 0.802731,
    height: 1.75941,
    rx: 0.401365,
    transform: "matrix(0.176145 0.984364 -0.984231 0.17689 77.1194 37.0361)",
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 0.799732,
    height: 1.76601,
    rx: 0.399866,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 75.2793 41.2815)",
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 0.799732,
    height: 1.76601,
    rx: 0.399866,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 74.7705 38.437)",
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 0.799732,
    height: 1.76601,
    rx: 0.399866,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 77.2891 37.9844)",
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 0.799732,
    height: 1.76601,
    rx: 0.399866,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 77.7979 40.8291)",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.319893,
    ry: 0.321092,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 79.7984 39.1543)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.319893,
    ry: 0.321092,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 80.0245 40.4184)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.542 11.5564C66.005 9.74384 69.0804 6.49966 69.7464 6.13529C70.0989 5.94247 70.8995 5.966 71.5442 6.1936C72.0469 5.9761 73.2845 6.02134 74.2132 7.94235C75.1043 9.78552 75.1345 12.1678 74.8631 13.6978C74.9195 13.4118 75.869 13.1092 76.3332 13.4336C76.7046 13.6931 76.9865 14.351 77.081 14.6475C78.4307 14.3239 79.9645 13.9471 81.2398 13.612C84.1884 12.8374 84.9897 12.775 85.4254 12.8598C85.861 12.9446 86.3565 15.8732 86.4414 16.3473C87.2226 15.9623 89.3598 16.3122 91.691 16.6272C94.0222 16.9423 99.4741 19.7142 100.61 20.1624C101.747 20.6107 102.048 20.4751 103.638 22.5544C105.229 24.6337 105.477 25.5678 105.609 27.6647C105.74 29.7616 104.277 31.5742 103.797 32.0683C103.413 32.4636 102.452 33.4791 102.019 33.9374C101.582 35.1252 100.774 36.3633 100.425 36.8338C100.797 37.0933 101.685 39.7882 102.698 40.911C103.712 42.0338 104.852 43.8678 106.257 45.8174C107.662 47.767 107.576 51.3711 107.193 53.3158C106.81 55.2605 103.853 56.4444 102.543 56.8429C102.749 57.5399 103.102 59.2382 102.865 60.4553C102.655 61.531 102.604 63.0675 101.777 64.3678C102.633 64.6063 104.39 65.7109 104.579 68.2215C104.816 71.3598 104.092 72.9581 102.951 73.6523C101.811 74.3466 98.1967 76.138 95.9503 76.2971L98.5803 90.9944L99.3014 95.0243C94.5149 96.7274 84.5236 99.7029 82.8506 97.9809C82.0282 94.4749 79.9376 85.1831 78.9952 80.9755C78.0117 76.9928 75.8427 68.4437 75.0351 66.1094C74.0255 63.1916 71.7843 57.4775 72.7529 56.08C71.8084 56.2498 70.9803 56.018 70.6843 55.8809C70.6701 55.3893 70.6518 54.9014 70.629 54.4228C70.5599 52.9735 70.4496 51.6095 70.2898 50.4873C69.901 47.7585 67.9602 44.8798 66.3477 42.9583C65.5224 41.975 64.7832 41.2424 64.3821 40.9088C64.2879 40.8306 64.2124 40.7743 64.1587 40.7419C63.5758 40.3899 62.9603 39.1901 62.7254 38.6342C62.7087 38.6017 62.6936 38.5659 62.68 38.5271C62.405 37.74 62.764 35.7042 63.1443 33.9917C63.3045 33.2703 63.4684 32.6063 63.5903 32.1172C63.7002 31.6764 63.7988 31.3844 63.9066 31.1602C63.9106 31.1518 63.9146 31.1435 63.9187 31.1353C64.2265 30.5137 64.6144 30.4142 65.5497 28.992C65.5821 28.9348 65.6224 28.8706 65.6705 28.8011C65.9306 28.3728 66.0948 27.9827 66.1986 27.6243C66.5381 26.4518 66.2311 25.619 66.5239 24.9021C66.655 24.5811 66.923 24.2265 67.2365 23.8904C67.8687 23.2129 68.6859 22.6106 68.9395 22.5105C69.3189 22.3608 70.5962 20.4185 71.4701 19.8536C71.8812 19.5879 72.358 18.8309 72.7536 18.0733C73.0308 17.5427 73.2681 17.0119 73.4152 16.6495C73.5068 16.5472 73.6611 16.3519 73.8413 16.0835C73.9872 15.8662 74.1503 15.601 74.3109 15.2985C74.3918 15.1461 74.4721 14.9844 74.5493 14.8145C74.6712 14.5461 74.781 14.161 74.8631 13.6978C75.1345 12.1678 75.1043 9.78552 74.2132 7.94235C73.2845 6.02134 72.0469 5.9761 71.5442 6.1936C72.1179 6.3961 72.5681 6.76015 72.4693 7.2771C72.2596 8.37507 68.7137 10.8066 67.7692 10.9764C66.8247 11.1462 65.7934 11.7393 64.542 11.5564Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8888 90.6544C13.2376 88.0633 15.0649 81.7485 19.5836 77.2173C25.2321 71.5532 33.9837 59.6223 34.4659 58.2307C34.9481 56.8391 35.3181 47.5564 36.6034 45.2049C37.8887 42.8534 41.3695 37.3342 41.658 36.2221C41.9464 35.11 47.9559 27.8315 48.5733 26.7418C49.1908 25.6521 53.6986 18.1541 55.9285 15.6328C58.1583 13.1115 61.2403 13.5363 64.542 11.5564M64.542 11.5564C66.005 9.74384 69.0804 6.49966 69.7464 6.13529C70.0989 5.94247 70.8995 5.966 71.5442 6.1936M64.542 11.5564C65.7934 11.7393 66.8247 11.1462 67.7692 10.9764C68.7137 10.8066 72.2596 8.37507 72.4693 7.2771C72.5681 6.76015 72.1179 6.3961 71.5442 6.1936M71.5442 6.1936C72.0469 5.9761 73.2845 6.02134 74.2132 7.94235C75.1043 9.78552 75.1345 12.1678 74.8631 13.6978M73.4152 16.6495C73.5161 16.3051 73.648 15.4984 73.3686 15.0267M73.4152 16.6495C73.2681 17.0119 73.0308 17.5427 72.7536 18.0733M73.4152 16.6495C73.5068 16.5472 73.6611 16.3519 73.8413 16.0835M66.5239 24.9021C66.7115 24.1344 67.037 22.412 66.8383 21.6648C66.6396 20.9175 66.3907 20.2228 66.2911 19.9688M66.5239 24.9021C66.2311 25.619 66.5381 26.4518 66.1986 27.6243M66.5239 24.9021C66.655 24.5811 66.923 24.2265 67.2366 23.8904M65.5497 28.992C64.602 30.433 64.2163 30.5161 63.9066 31.1602M65.5497 28.992C65.8812 28.4879 66.0796 28.0352 66.1986 27.6243M65.5497 28.992C65.8119 28.5292 66.5901 27.6089 67.815 27.1231M62.7254 38.6342C62.4953 38.1047 61.9642 36.6505 61.6814 35.0702C61.328 33.0947 60.2962 30.5071 59.7471 29.7087M62.7254 38.6342C62.9603 39.1901 63.5758 40.3899 64.1587 40.7419C64.2124 40.7743 64.2879 40.8306 64.3821 40.9088M62.7254 38.6342C62.3696 37.9416 62.7453 35.7887 63.1443 33.9917M63.9066 31.1602C63.7988 31.3844 63.7002 31.6764 63.5903 32.1172C63.4684 32.6063 63.3045 33.2703 63.1443 33.9917M63.9066 31.1602C64.1246 30.7142 64.6371 29.6128 64.9421 28.775C65.3234 27.7277 65.6402 26.7737 65.3475 26.5M62.7484 85.5266C62.6391 83.0995 65.7989 77.1487 66.7392 75.5932C67.294 74.6753 68.3181 72.1112 69.1477 69.6959M32.6173 73.3251C34.6946 71.9187 38.8495 68.2902 38.8507 65.0277C38.8521 60.9494 38.9727 57.9916 41.1762 54.4148C43.3797 50.838 47.706 44.596 47.4553 41.3787M66.1986 27.6243C66.2674 27.4036 66.6699 26.8985 67.7291 26.6429M67.7291 26.6429L67.815 27.1231M67.7291 26.6429C67.276 25.2004 67.2119 24.2069 67.2366 23.8904M96.5876 45.3532L95.3989 45.9746M96.5876 45.3532C96.4941 44.7713 96.3864 44.1018 96.2686 43.3715M96.5876 45.3532C97.3636 44.9147 99.6776 44.2595 102.725 45.1473M95.3989 45.9746L92.5003 29.7759C92.2228 27.9228 90.6604 24.3975 86.6303 25.1218C81.5928 26.0271 71.9758 27.674 68.7627 28.333C65.5497 28.992 64.1493 31.6089 64.6442 34.3745L66.3477 42.9583M95.3989 45.9746C94.7571 46.1715 93.124 46.7913 91.7258 47.695C90.4435 48.5239 89.0438 50.1643 88.4557 51.7082M88.1805 53.3073C88.3483 55.153 88.2799 57.0412 89.479 58.2937M88.1805 53.3073C83.4315 54.1608 73.6975 55.9103 72.7529 56.08M88.1805 53.3073C88.1358 52.8159 88.2424 52.2684 88.4557 51.7082M89.479 58.2937C90.678 59.5463 91.435 60.1443 93.4674 59.6975C94.9236 59.3773 98.2803 58.255 100.548 57.4978M89.479 58.2937C88.7564 58.342 87.005 58.5426 85.7795 58.9586C84.2477 59.4786 81.275 61.4809 81.982 65.4318C82.689 69.3827 85.1776 69.6695 86.7156 69.6378C87.9742 69.6118 89.8141 68.8805 91.7075 68.4775M102.543 56.8429C103.853 56.4444 106.81 55.2605 107.193 53.3158C107.576 51.3711 107.662 47.767 106.257 45.8174C104.852 43.8678 103.712 42.0338 102.698 40.911C101.685 39.7882 100.797 37.0933 100.425 36.8338M102.543 56.8429C102.749 57.5399 103.102 59.2382 102.865 60.4553C102.655 61.531 102.604 63.0675 101.777 64.3678M102.543 56.8429C102.172 56.9559 101.445 57.1983 100.548 57.4978M100.425 36.8338C100.322 37.0154 100.045 37.3425 99.7592 37.1982M100.425 36.8338C100.774 36.3633 101.582 35.1252 102.019 33.9374M66.3477 42.9583C67.9602 44.8798 69.901 47.7585 70.2898 50.4873C70.4496 51.6095 70.5599 52.9735 70.629 54.4228M66.3477 42.9583C65.5224 41.975 64.7832 41.2424 64.3821 40.9088M63.1443 33.9917L64.3821 40.9088M70.6843 55.8809C70.7971 59.8077 70.6422 63.9669 70.3727 65.4793C70.2065 66.4119 69.7241 68.018 69.1477 69.6959M70.6843 55.8809C70.9803 56.018 71.8084 56.2498 72.7529 56.08M70.6843 55.8809C70.6701 55.3893 70.6518 54.9014 70.629 54.4228M72.7529 56.08C71.7843 57.4775 74.0255 63.1916 75.0351 66.1094C75.8427 68.4437 78.0117 76.9928 78.9952 80.9755M70.629 54.4228C71.1949 54.4842 73.0038 54.4853 75.7115 53.9987C78.4192 53.512 85.3359 52.2689 88.4557 51.7082M87.7425 23.6185C87.3547 23.6096 86.9514 23.6267 86.5333 23.6712C78.689 24.7825 70.5406 26.4639 68.5082 26.9107C68.2634 26.9645 68.0322 27.037 67.815 27.1231M87.7425 23.6185C87.6332 23.4955 87.4756 23.2998 87.3199 23.0728M87.7425 23.6185C88.9699 23.6463 90.0412 23.9333 90.9335 24.4299M84.8648 14.347C85.3795 14.4992 85.3271 15.5689 85.412 16.043C85.4358 16.176 85.5314 16.4245 85.6601 16.7324M84.8648 14.347C84.3501 14.1949 78.3156 16.3397 77.8575 16.5036M84.8648 14.347C84.8224 14.11 84.7516 13.7149 84.1078 13.7491C83.7492 13.7681 80.468 14.5206 77.4252 15.2348M77.8575 16.5036C77.3994 16.6675 76.132 17.303 75.3811 17.1933M77.8575 16.5036C77.807 16.2292 77.6497 15.5912 77.4252 15.2348M75.3811 17.1933C74.5295 17.4279 72.8987 17.8026 72.7536 18.0733M75.3811 17.1933C75.1756 16.8012 74.7592 15.9876 74.7381 15.8697M72.7536 18.0733C72.358 18.8309 71.8812 19.5879 71.4701 19.8536C70.5962 20.4185 69.3189 22.3608 68.9395 22.5105C68.6859 22.6106 67.8687 23.2129 67.2366 23.8904M87.3199 23.0728C87.0891 22.7365 86.8622 22.3314 86.8014 21.9918C86.7113 21.4883 86.7507 20.7981 86.7262 20.1294M87.3199 23.0728C87.309 22.6561 87.175 21.4842 86.7262 20.1294M86.7262 20.1294C86.7161 19.8536 86.6951 19.5814 86.6497 19.3276C86.5378 18.7023 85.9902 17.522 85.6601 16.7324M85.6601 16.7324C85.9488 16.7621 86.5092 16.7266 86.4414 16.3473M86.4414 16.3473C86.3565 15.8732 85.861 12.9446 85.4254 12.8598C84.9897 12.775 84.1884 12.8374 81.2398 13.612C79.9645 13.9471 78.4307 14.3239 77.081 14.6475M86.4414 16.3473C87.2226 15.9623 89.3598 16.3122 91.691 16.6272C94.0222 16.9423 99.4741 19.7142 100.61 20.1624C101.747 20.6107 102.048 20.4751 103.638 22.5544C105.229 24.6337 105.477 25.5678 105.609 27.6647C105.74 29.7616 104.277 31.5742 103.797 32.0683C103.413 32.4636 102.452 33.4791 102.019 33.9374M74.3109 15.2985C74.3918 15.1461 74.4721 14.9844 74.5493 14.8145C74.6712 14.5461 74.781 14.161 74.8631 13.6978M74.3109 15.2985C74.1503 15.601 73.9872 15.8662 73.8413 16.0835M74.3109 15.2985C74.9204 15.1589 75.9342 14.9224 77.081 14.6475M73.8413 16.0835C74.1175 16.0175 74.4184 15.9458 74.7381 15.8697M77.4252 15.2348C76.474 15.458 75.5461 15.6775 74.7381 15.8697M77.081 14.6475C76.9865 14.351 76.7046 13.6931 76.3332 13.4336C75.869 13.1092 74.9195 13.4118 74.8631 13.6978M94.2876 31.249C94.1066 30.1681 93.956 29.2849 93.8544 28.717C93.7976 28.3996 93.7219 28.0929 93.6279 27.798M94.2876 31.249L95.0153 31.1182C95.0187 31.1679 95.0227 31.2217 95.0273 31.2792M94.2876 31.249C94.4439 32.1827 94.6228 33.2639 94.8124 34.4171M94.8124 34.4171C94.9636 34.3899 95.329 34.3242 95.5809 34.279C95.5507 34.2097 95.5217 34.1329 95.4939 34.0499M94.8124 34.4171C94.8659 34.743 94.9204 35.0747 94.9754 35.4105M95.0273 31.2792C95.2164 31.2452 95.626 31.1716 95.752 31.149C95.9094 31.1207 96.0791 32.0689 96.0569 32.3991C96.0348 32.7293 96.2549 33.5053 96.2044 33.6775C96.154 33.8497 96.172 34.0096 95.4939 34.0499M95.0273 31.2792C95.0852 31.9977 95.2381 33.2852 95.4939 34.0499M95.7302 40.0428L96.5403 39.8972C96.5453 39.9673 96.5519 40.0483 96.5601 40.1383M95.7302 40.0428C95.9214 41.2214 96.1047 42.3552 96.2686 43.3715M95.7302 40.0428C95.4834 38.521 95.2235 36.9247 94.9754 35.4105M96.2686 43.3715C96.4408 43.3406 96.8549 43.2662 97.1341 43.216C97.1258 43.1905 97.1175 43.1648 97.1093 43.1389M96.5601 40.1383C96.8139 40.0655 97.34 39.9329 97.4143 39.9848C97.5072 40.0497 97.7697 41.0628 97.8404 41.4579C97.9111 41.853 98.1091 42.9592 97.9516 42.9875C97.8257 43.0101 97.3376 43.0979 97.1093 43.1389M96.5601 40.1383C96.6263 40.8576 96.7995 42.1585 97.1093 43.1389M99.7592 37.1982C100.492 35.8431 101.113 36.1392 100.618 33.3736C100.124 30.608 99.1366 30.5407 99.4957 29.8236C99.8549 29.1066 99.9355 28.195 100.408 28.1101C100.88 28.0252 101.974 28.2364 102.251 29.3285C102.527 30.4206 102.566 32.4527 102.019 33.9374M99.7592 37.1982C97.2389 38.3689 95.5199 36.4942 94.9754 35.4105M93.4522 27.3123C93.5117 26.607 93.8863 24.9002 94.9092 23.7154C96.1879 22.2345 98.0754 21.4321 100.308 21.1955M93.4522 27.3123C93.5165 27.4703 93.5751 27.6323 93.6279 27.798M93.4522 27.3123C92.9469 26.0708 92.0907 25.074 90.9335 24.4299M93.6279 27.798C93.8197 27.2407 94.6528 25.9147 96.4514 25.0694M90.9335 24.4299C91.0162 23.4364 91.4073 21.2619 92.3095 20.5125M88.3677 22.1181C88.4866 21.118 88.852 19.0133 89.3622 18.5954M102.178 26.6502C102.735 27.0394 103.83 28.1639 103.752 29.548M100.548 57.4978C101.178 57.9926 102.337 59.5061 101.932 61.6016M101.777 64.3678C101.435 64.9065 100.959 65.4046 100.284 65.8126C99.818 66.0944 99.3356 66.3524 98.8436 66.5868M101.777 64.3678C102.633 64.6063 104.39 65.7109 104.579 68.2215C104.816 71.3598 104.092 72.9581 102.951 73.6523C101.811 74.3466 98.1967 76.138 95.9503 76.2971M95.9503 76.2971L95.3706 73.0574M95.9503 76.2971L98.5803 90.9944L99.3014 95.0243C94.5149 96.7274 84.5236 99.7029 82.8506 97.981C82.0282 94.4749 79.9376 85.1831 78.9952 80.9755M97.485 67.1667C95.9545 67.7484 94.3892 68.1141 92.9701 68.269C92.5504 68.3148 92.1277 68.3881 91.7075 68.4775M97.485 67.1667C97.7084 67.6585 97.9558 68.8899 97.1583 69.8815C96.1615 71.1209 96.6842 70.8638 97.1706 70.858C97.657 70.8521 99.7115 70.0751 99.786 68.6752C99.8456 67.5553 99.1825 66.8163 98.8436 66.5868M97.485 67.1667C97.9426 66.9927 98.397 66.7995 98.8436 66.5868M91.7075 68.4775C91.9233 69.5323 92.9581 71.925 95.3706 73.0574M95.3706 73.0574C97.783 74.1897 98.9634 74.3691 99.252 74.3172M78.9952 80.9755C77.6626 82.0034 74.8625 84.214 74.3233 84.8329C73.6493 85.6065 72.8763 85.8269 72.0652 87.1961C71.254 88.5653 67.7874 94.1634 63.5756 96.9594C60.2061 99.1961 54.3064 103.274 51.7777 105.034M48.1122 103.164C49.9942 100.515 53.5829 94.2369 52.8816 90.3176M53.2384 100.938C55.5322 98.6225 60.119 93.7147 60.1156 92.6061M69.1477 69.6959C69.8894 70.7588 71.5029 73.6115 72.0233 76.5194C72.5436 79.4273 72.5609 81.6426 72.5045 82.3867M92.8537 58.9922C93.6952 57.9438 94.8924 54.8577 92.9494 50.9006C94.4812 50.3806 97.436 50.0943 98.1204 51.1947C98.8047 52.295 98.906 55.1314 98.2179 55.826C97.5298 56.5206 94.1414 58.9239 92.8537 58.9922ZM85.4218 69.2178C84.8846 67.2754 84.044 63.1528 84.9787 62.2018C86.454 61.3657 90.095 61.2823 91.3605 61.5442C92.626 61.8061 93.9 64.8395 92.1948 66.2062C90.8306 67.2996 87.111 68.6695 85.4218 69.2178ZM84.1223 71.4903C83.9932 71.6767 83.9669 71.8934 84.3787 72.0152C84.7864 72.0235 86.8692 71.4044 87.4202 71.3054C87.735 71.2488 87.9005 70.8113 87.5573 70.7099C87.2142 70.6084 84.6733 71.3913 84.1223 71.4903ZM85.1602 74.5662C85.031 74.7525 84.9261 74.9834 85.3378 75.1052C85.7455 75.1134 87.4348 74.5652 87.9858 74.4661C88.3006 74.4096 88.2158 73.9354 87.8727 73.834C87.5295 73.7325 85.7111 74.4672 85.1602 74.5662ZM86.0062 77.024C85.877 77.2103 85.6793 77.3764 86.091 77.4981C86.4987 77.5064 87.6511 77.1362 88.2021 77.0372C88.517 76.9806 88.4463 76.5855 88.1031 76.484C87.76 76.3826 86.5572 76.925 86.0062 77.024ZM86.6302 79.6033C86.5011 79.7896 86.3033 79.9557 86.7151 80.0774C87.1228 80.0857 88.2752 79.7155 88.8261 79.6165C89.141 79.5599 89.0986 79.3228 88.7555 79.2214C88.4123 79.1199 87.1812 79.5043 86.6302 79.6033ZM86.9536 82.3182C86.8244 82.5045 86.7336 82.8145 87.1454 82.9362C87.5531 82.9445 88.8629 82.546 89.4139 82.4469C89.7287 82.3904 89.6298 81.8372 89.2866 81.7358C88.9435 81.6343 87.5045 82.2192 86.9536 82.3182ZM87.62 85.1346C87.4909 85.3209 87.4001 85.6308 87.8118 85.7526C88.2195 85.7608 89.5294 85.3623 90.0803 85.2633C90.3952 85.2067 90.3891 84.7185 90.0459 84.617C89.7028 84.5156 88.171 85.0355 87.62 85.1346Z",
    stroke: "#E4E7E7"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: -0.162169,
    y: 0.233044,
    width: 0.401365,
    height: 1.35804,
    rx: 0.200683,
    transform: "matrix(0.176145 0.984364 -0.984231 0.17689 84.2098 41.8292)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.401365
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: -0.162169,
    y: 0.233044,
    width: 0.401365,
    height: 1.35804,
    rx: 0.200683,
    transform: "matrix(0.176145 0.984364 -0.984231 0.17689 83.1917 36.14)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.401365
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 0.231997,
    y: 0.161441,
    width: 0.399866,
    height: 1.36614,
    rx: 0.199933,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 70.8934 42.2621)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.399866
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: -0.162169,
    y: 0.233044,
    width: 0.401365,
    height: 1.35804,
    rx: 0.200683,
    transform: "matrix(0.176145 0.984364 -0.984231 0.17689 73.8721 44.0133)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.401365
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: -0.162169,
    y: 0.233044,
    width: 0.401365,
    height: 1.35804,
    rx: 0.200683,
    transform: "matrix(0.176145 0.984364 -0.984231 0.17689 73.3631 41.1686)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.401365
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: -0.162169,
    y: 0.233044,
    width: 0.401365,
    height: 1.35804,
    rx: 0.200683,
    transform: "matrix(0.176145 0.984364 -0.984231 0.17689 72.8541 38.3241)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.401365
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 0.231997,
    y: 0.161441,
    width: 0.399866,
    height: 1.36614,
    rx: 0.199933,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 70.3839 39.4171)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.399866
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 0.231997,
    y: 0.161441,
    width: 0.399866,
    height: 1.36614,
    rx: 0.199933,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 73.4125 41.8089)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.399866
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 0.231997,
    y: 0.161441,
    width: 0.399866,
    height: 1.36614,
    rx: 0.199933,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 81.2311 40.078)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.399866
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 0.231997,
    y: 0.161441,
    width: 0.399866,
    height: 1.36614,
    rx: 0.199933,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 80.722 37.2333)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.399866
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 0.231997,
    y: 0.161441,
    width: 0.399866,
    height: 1.36614,
    rx: 0.199933,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 83.2406 36.7806)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.399866
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 0.231997,
    y: 0.161441,
    width: 0.399866,
    height: 1.36614,
    rx: 0.199933,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 83.7496 39.6251)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.399866
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: -0.162169,
    y: 0.233044,
    width: 0.401365,
    height: 1.35804,
    rx: 0.200683,
    transform: "matrix(0.176145 0.984364 -0.984231 0.17689 88.826 40.8908)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.401365
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: -0.162169,
    y: 0.233044,
    width: 0.401365,
    height: 1.35804,
    rx: 0.200683,
    transform: "matrix(0.176145 0.984364 -0.984231 0.17689 87.8077 35.2016)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.401365
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 0.231997,
    y: 0.161441,
    width: 0.399866,
    height: 1.36614,
    rx: 0.199933,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 85.847 39.1393)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.399866
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 0.231997,
    y: 0.161441,
    width: 0.399866,
    height: 1.36614,
    rx: 0.199933,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 85.338 36.2948)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.399866
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 0.231997,
    y: 0.161441,
    width: 0.399866,
    height: 1.36614,
    rx: 0.199933,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 87.8566 35.8421)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.399866
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 0.231997,
    y: 0.161441,
    width: 0.399866,
    height: 1.36614,
    rx: 0.199933,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 88.3656 38.6866)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.399866
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: -0.162169,
    y: 0.233044,
    width: 0.401365,
    height: 1.35804,
    rx: 0.200683,
    transform: "matrix(0.176145 0.984364 -0.984231 0.17689 78.2335 43.0766)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.401365
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: -0.162169,
    y: 0.233044,
    width: 0.401365,
    height: 1.35804,
    rx: 0.200683,
    transform: "matrix(0.176145 0.984364 -0.984231 0.17689 77.2151 37.3876)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.401365
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 0.231997,
    y: 0.161441,
    width: 0.399866,
    height: 1.36614,
    rx: 0.199933,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 75.2545 41.3251)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.399866
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 0.231997,
    y: 0.161441,
    width: 0.399866,
    height: 1.36614,
    rx: 0.199933,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 74.7457 38.4806)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.399866
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 0.231997,
    y: 0.161441,
    width: 0.399866,
    height: 1.36614,
    rx: 0.199933,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 77.2643 38.0279)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.399866
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 0.231997,
    y: 0.161441,
    width: 0.399866,
    height: 1.36614,
    rx: 0.199933,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 77.7731 40.8727)",
    fill: "white",
    stroke: "#E4E7E7",
    strokeWidth: 0.399866
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.319893,
    ry: 0.321092,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 79.7984 39.1543)",
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.319893,
    ry: 0.321092,
    transform: "matrix(0.984231 -0.17689 0.176145 0.984364 80.0245 40.4184)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDeadlines);
export default __webpack_public_path__ + "static/media/no-deadlines.03f1a98dde811efbd2c29a60729b4b9e.svg";
export { ForwardRef as ReactComponent };